export const isEnvironmentProduction = () => {
   if ((process.env.REACT_APP_UPWARD_ENV !== 'production')
   && (process.env.REACT_APP_UPWARD_ENV !== 'rc')
   && (process.env.REACT_APP_UPWARD_ENV !== 'rcprod')) {
      return false;
   }
   return true;
};

export const isDebugLogging = () => {
   return !isEnvironmentProduction();
};

export const isInfoLogging = () => {
   return !isEnvironmentProduction();
};
